import { get } from "@insite/client-framework/Services/ApiService";
import { BranchSelectionResultModel } from "@WhiteCap/Handlers/BranchSelection/HandleBranchSelection";

const branchSelectionUrl = "/api/v1/branchSelection";

/** Loads warehouse "594" (geo fallback) for session branch when browser geolocation is unavailable. */
export function getGeoFallbackBranch(): Promise<BranchSelectionResultModel> {
    return get<BranchSelectionResultModel>(`${branchSelectionUrl}/geoFallback`);
}
